import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HideDirective } from './hide/hide.directive';
import { RepeatDirective } from './repeat/repeat.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [HideDirective, RepeatDirective],
  exports: [RepeatDirective, HideDirective],
})
export class DirectivesModule {}
